import { gql } from '@apollo/client';

import { EntityFieldsQueryOperationQuery } from 'core/graphql';

import { useQuery } from './useQuery';

const sort = ({ field: a }, { field: b }) => {
  if (a === b) {
    return 0;
  }
  return a > b ? 1 : -1;
};

const RULE_ENTITY_FIELDS_QUERY = gql`
  query EntityFieldsQueryOperation {
    entityFieldsWithTypes {
      field
      type
    }
  }
`;

export const useSortedEntityFields = () => {
  const { loading, data = { entityFieldsWithTypes: [] } } =
    useQuery<EntityFieldsQueryOperationQuery>(RULE_ENTITY_FIELDS_QUERY);
  return {
    loading,
    entityFields: [...(data.entityFieldsWithTypes ?? [])].sort(sort),
  };
};
